import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import { useCallback, useEffect, useState } from 'react';
import { GSVSService } from 'services/GSVSServise';
import { GSVSForm } from './GSVSForm';
import { GSVSTable } from './GSVSTable';

function GSVS() {
  useDocumentTitle('Глобальный справочник виртуального склада');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger(
    'Глобальный справочник виртуального склада'
  );
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const fetchItems = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items = [], total } = await GSVSService.getGSVS(page, perPage);
      setTotalRows(total);
      setItems(items);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await GSVSService.deleteGSVS(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="GSVS" />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          {
            label: 'КПВЕД',
            key: 'kpved_code',
          },
          {
            label: 'ТНВЕД',
            key: 'tnved_code',
          },
          {
            label: 'Название',
            key: 'name',
          },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="GSVS"
      />

      <GSVSTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <GSVSForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { GSVS };
